import type { MessagingUpdateRequest, MessagingView } from '@/types/messaging';
import { ApiService } from './api.service';

class MessagingService extends ApiService {
  public async getMessaging(churchId: string): Promise<MessagingView> {
    const url = `/api/v1/churches/${churchId}/messaging`;
    const response = await this.get<MessagingView>(url);
    return response.data;
  }

  public async updateMessaging(churchId: string, payload: MessagingUpdateRequest): Promise<MessagingView> {
    const url = `/api/v1/churches/${churchId}/messaging`;
    const response = await this.put<MessagingView>(url, payload);
    return response.data;
  }
}

export const messagingService = new MessagingService();
